import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid2, Box, Typography, Button, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Checkbox, TextField, Autocomplete } from '@mui/material';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { startOfMonth, format } from 'date-fns';
import { srLatn } from 'date-fns/locale';
import { getEmployees } from '../../api/axios';

const ReportParameters = () => {
  const [startDate, setStartDate] = useState(startOfMonth(new Date()));
  const [endDate, setEndDate] = useState(new Date());
  const [selectedEmployees, setSelectedEmployees] = useState([]); // Promenjeno na niz
  const [displayType, setDisplayType] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [employees, setEmployees] = useState([]);
  const [option1, setOption1] = useState(false);
  const [option2, setOption2] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
          console.warn('Access token is missing.');
          return;
        }
        const response = await getEmployees(accessToken);
        if (response?.data?.employees) {
          const transformedEmployees = response.data.employees.map((employee) => ({
            card_serial: employee.card_serial,
            name: employee.name,
            lastname: employee.lastname,
          }));
          setEmployees(transformedEmployees);
        } else {
          console.warn('No employees data received.');
          setEmployees([]);
        }
      } catch (error) {
        console.error('Error fetching employees:', error);
        setEmployees([]);
      }
    };
  
    fetchEmployees();
  }, []);

  const handleConfirm = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) {
      console.warn('No access token found.');
      return;
    }
  
    const formattedStartDate = format(startDate, 'yyyy-MM-dd');
    const formattedEndDate = format(endDate, 'yyyy-MM-dd');
  
    // Kolekcija za otvaranje više prozora
    const windows = selectedEmployees.map((employee) => {
      const params = {
        accessToken,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        employeeId: employee.card_serial,
        displayType,
      };
  
      const queryString = new URLSearchParams(params).toString();
      return () => window.open(`/showingReports?${queryString}`, '_blank');
    });
  
    // Otvori sve prozore odjednom
    windows.forEach((openWindow) => openWindow());
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={srLatn}>
      <Grid2 container spacing={4} sx={{ maxWidth: 1200, margin: 'auto' }}>
        <Grid2 item xs={12} sm={4} md={4} lg={4} xl={4} display="flex" flexDirection="column" gap={2} flexGrow={1} >
          <Autocomplete
            multiple
            fullWidth
            options={employees}
            getOptionLabel={(option) => `${option.name} ${option.lastname}`} // Prikazuje ime i prezime
            value={selectedEmployees}
            onChange={(event, newValue) => setSelectedEmployees(newValue)} // Čuva ceo objekat
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Employees"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                fullWidth
              />
            )}
            isOptionEqualToValue={(option, value) => option.card_serial === value.card_serial} // Upoređuje preko card_serial
          />
          <FormControl fullWidth>
            <InputLabel>Display Type</InputLabel>
            <Select
              value={displayType}
              onChange={(e) => setDisplayType(e.target.value)}
            >
              <MenuItem value="type1">Type 1</MenuItem>
              <MenuItem value="type2">Type 2</MenuItem>
            </Select>
          </FormControl>

          <Box display="flex" flexDirection="column">
            <FormControlLabel
              control={<Checkbox checked={option1} onChange={(e) => setOption1(e.target.checked)} />}
              label="Option 1"
            />
            <FormControlLabel
              control={<Checkbox checked={option2} onChange={(e) => setOption2(e.target.checked)} />}
              label="Option 2"
            />
          </Box>

          <Box display="flex" justifyContent="flex-end">
            <Button variant="contained" onClick={handleConfirm} sx={{ width: '50%' }}>
              Confirm
            </Button>
          </Box>
        </Grid2>

        <Grid2 item xs={12} sm={4} md={4} lg={4} xl={4} display="flex" flexDirection="column" alignItems="center">
          <Typography variant="subtitle1" gutterBottom>
            Start Date
          </Typography>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
          />
        </Grid2>

        <Grid2 item xs={12} sm={4} md={4} lg={4} xl={4} display="flex" flexDirection="column" alignItems="center">
          <Typography variant="subtitle1" gutterBottom>
            End Date
          </Typography>
          <StaticDatePicker
            displayStaticWrapperAs="desktop"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
          />
        </Grid2>
      </Grid2>
    </LocalizationProvider>
  );
};

export default ReportParameters;
